import _objectWithoutProperties from "/jenkins/workspace/jenkins-prod-pipelines-LOS-UI-LOS-UI-Release-prod-3/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { Component } from "react";
import TextFieldMasked from "./TextFieldMasked";
import { Field } from "redux-form";
// import { Field } from 'react-final-form';

class TextField extends Component {
  constructor(props) {
    super(props);
    this.handleOnKeyUp = e => {
      if (e.target.value.length === this.props.fieldLength) {
        if (e.key !== "Tab") {
          if (this.reachedMax && this.props.toggleSnackbar) {
            this.props.toggleSnackbar(true, "You have reached the maximum length of this input field", "red");
          } else {
            this.reachedMax = true;
          }
        }
      } else {
        this.reachedMax = false;
      }
    };
  }
  handleChangeRequirement(value) {
    if (this.props.changeRequirement) this.props.changeRequirement(value);
  }
  render() {
    const _this$props = this.props,
      context = _this$props.context,
      fieldName = _this$props.fieldName,
      other = _objectWithoutProperties(_this$props, ["context", "fieldName"]);
    return /*#__PURE__*/React.createElement(Field, Object.assign({
      context: context,
      name: fieldName,
      component: TextFieldMasked,
      onKeyUp: this.handleOnKeyUp,
      required: this.props.required,
      validate: this.props.validation,
      fullWidth: this.props.fullWidth,
      showMargin: this.props.showMargin,
      margin: this.props.margin,
      labelShrink: true,
      onBlur: e => {
        if (this.handleChangeRequirement) this.handleChangeRequirement(e.target.value);
      },
      ref: this.saveRef,
      forwardRef: true
    }, other));
  }
}
export default TextField;